import { render, staticRenderFns } from "./StateList.vue?vue&type=template&id=7b72e164&scoped=true&"
import script from "./StateList.vue?vue&type=script&lang=js&"
export * from "./StateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b72e164",
  null
  
)

export default component.exports